"use client"

import { useEffect } from "react"

import { useAppUser } from "@/lib/useAppUser"

import {
  clearAuthenticatedUser,
  setAuthenticatedUser,
} from "./app-insights-global"

/**
 * Bridges the BFF session into App Insights' authenticated-user context (M21):
 * signed in → telemetry tagged with the pseudonymous Entra OID (a GUID — never
 * email/name, per the privacy stance), signed out → cleared. Uses the global
 * handle rather than the React context so it works anywhere in the tree and is
 * trivially testable. Renders nothing.
 */
export function AppInsightsUserContext() {
  const { user } = useAppUser()
  const userId = user?.userId ?? null

  useEffect(() => {
    if (userId) setAuthenticatedUser(userId)
    else clearAuthenticatedUser()
  }, [userId])

  return null
}
